import { TextInput } from "@mantine/core";
import { IconSearch } from "@tabler/icons-react";
import { Dispatch, useCallback } from "react";
import { CatalogueAction } from "../../../hooks/admin/useSystemEmailsPage";

interface Props {
  value: string;
  dispatch: Dispatch<CatalogueAction>;
}

export function SystemEmailSearchFilter({ value, dispatch }: Props) {
  const change = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) =>
      dispatch({ type: "search", value: event.currentTarget.value }),
    [dispatch]
  );
  return (
    <TextInput
      label="Search catalogue"
      leftSection={<IconSearch size={16} />}
      onChange={change}
      placeholder="Search email, subject, or trigger"
      value={value}
    />
  );
}
